"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    children: _propTypes.default.any.isRequired,
    href: _propTypes.default.string.isRequired,
    queryParams: _propTypes.default.object,
    type: _propTypes.default.oneOf(Object.keys(_constant2.REDIRECTION_TYPE)),
    target: _propTypes.default.oneOf(Object.keys(_constant2.LINK_TARGET)),
    size: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    underlined: _propTypes.default.bool,
    hoverUnderlined: _propTypes.default.bool,
    alignHeadlineContainer: _propTypes.default.string,
    justifyContent: _propTypes.default.string,
    gtmEventData: _propTypes.default.string,
    hoverColor: _propTypes.default.string,
    fireGtm: _propTypes.default.func,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    callback: _propTypes.default.func,
    idConfig: _propTypes.default.exact({
      parentName: _propTypes.default.string,
      widgetName: _propTypes.default.string,
      index: _propTypes.default.string
    }),
    linkname: _propTypes.default.string,
    updateGtmId: _propTypes.default.func,
    gaID: _propTypes.default.string,
    stopPropagation: _propTypes.default.string,
    clickable: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    target: _constant2.LINK_TARGET.tab.type,
    color: 'primary',
    size: _constant.DEFAULT_FONT_SIZE,
    hoverUnderlined: true,
    type: _constant2.REDIRECTION_TYPE.normal,
    stopPropagation: true,
    clickable: true
  }
};
exports.default = _default;